var _a;
import { SearchDocumentType } from '@wix/client-search-sdk';
export var defaultCategoryList = (_a = {},
    _a[SearchDocumentType.All] = {
        index: 100,
        visible: true,
        useOverride: false,
        override: '',
    },
    _a[SearchDocumentType.Products] = {
        index: 110,
        visible: true,
        useOverride: false,
        override: '',
    },
    _a[SearchDocumentType.Bookings] = {
        index: 120,
        visible: true,
        useOverride: false,
        override: '',
    },
    _a[SearchDocumentType.Events] = {
        index: 130,
        visible: true,
        useOverride: false,
        override: '',
    },
    _a[SearchDocumentType.Blogs] = {
        index: 140,
        visible: true,
        useOverride: false,
        override: '',
    },
    _a[SearchDocumentType.Pages] = {
        index: 150,
        visible: true,
        useOverride: false,
        override: '',
    },
    _a[SearchDocumentType.Forums] = {
        index: 160,
        visible: true,
        useOverride: false,
        override: '',
    },
    _a[SearchDocumentType.Programs] = {
        index: 170,
        visible: true,
        useOverride: false,
        override: '',
    },
    _a[SearchDocumentType.ProGallery] = {
        index: 180,
        visible: true,
        useOverride: false,
        override: '',
    },
    _a);
//# sourceMappingURL=categoryList.js.map